var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.512,
    height: 11.072,
    viewBox: "0 0 17.512 11.072",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "left-arrow",
    transform: "translate(-5 -132)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14704",
    "data-name": "Group 14704",
    transform: "translate(5 132)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33870",
    "data-name": "Path 33870",
    d: "M5.828,136.643h13.85l-2.905-3.117a.943.943,0,0,1,0-1.263.786.786,0,0,1,1.171,0l4.327,4.643h0a.944.944,0,0,1,0,1.264h0l-4.327,4.643a.786.786,0,0,1-1.171,0,.943.943,0,0,1,0-1.263l2.905-3.117H5.828a.9.9,0,0,1,0-1.786Z",
    transform: "translate(-5 -132)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.34b69eb096027e9c675d341b27f99365.svg";
export { ForwardRef as ReactComponent };